import * as React from 'react';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const FloorFieldContainer: React.FC = () => {
  const { floor, published } = useOfferContext();

  if (!floor) {
    return <EmptyField published={published} />;
  }

  return <TextField published={published}>{floor}</TextField>;
};
